import CosmicService from "../services/cosmicService";

export default class CosmicController {
	static async getTexts() {
		const result = {
			success: false,
			message: "",
		};

		try {
			result.data = await CosmicService.getTexts();
			result.success = true;
			return result;
		} catch (error) {
			result.message = "Ошибка при получении текстов";
			return result;
		}
	}

	static async getPosts() {
		const result = {
			success: false,
			message: "",
		};

		try {
			result.data = await CosmicService.getPosts();
			result.success = true;
			return result;
		} catch (error) {
			result.message = "Ошибка при получении статей";
			return result;
		}
	}

	static async getPostBySlug(slug) {
		const result = {
			success: false,
			message: "",
		};

		try {
			result.data = await CosmicService.getPostBySlug(slug);
			result.success = true;
			return result;
		} catch (error) {
			result.message = `Ошибка при получении статьи по slug "${slug}"`;
			return result;
		}
	}

	static async getAnnouncement() {
		const result = {
			success: false,
			message: "",
		};

		try {
			result.data = await CosmicService.fetchAnnouncement();
			result.success = true;
			return result;
		} catch (error) {
			result.message = "Ошибка при получении предложения";
			return result;
		}
	}
}
